import { render } from "./IndicatorDate.vue?vue&type=template&id=fefd1b46&scoped=true"
import script from "./IndicatorDate.vue?vue&type=script&lang=js"
export * from "./IndicatorDate.vue?vue&type=script&lang=js"

import "./IndicatorDate.vue?vue&type=style&index=0&id=fefd1b46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fefd1b46"]])

export default __exports__